export const shouldCollapseNavbar = (layoutType: string, layoutName: string) =>
  layoutType === "rl" &&
  (layoutName === "Tier 1 Analyst" || layoutName === "AI Summary");
